import Feature from 'ol/Feature';
import { WGisEngine } from './wgis.engine';
import {
  EngineType,
  FieldsInterface,
  MapEngineOptions,
  BaseEngine,
  WGisServiceInterface,
  WGisFeatureInfo,
  WGisFeatureInterface
} from './wgis.utils';

import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import { Options as WmsOptions } from 'ol/source/ImageWMS';


export class WGisWmsEngine extends WGisEngine implements BaseEngine {

  source: ImageWMS;

  constructor(options: MapEngineOptions, wgisService: WGisServiceInterface) {
    super(options, wgisService);
    this.createLayer();
  }

  createLayer() {
    this.type = EngineType.WMS;
    const options: WmsOptions = {
      url: this.url,
      params: this.params,
    };

    if (this.attributions) { options.attributions = this.attributions; }
    if (this.crossOrigin) { options.crossOrigin = this.crossOrigin; }
    if (this.hidpi) { options.hidpi = this.hidpi; }
    if (this.serverType) { options.serverType = this.serverType; }
    if (this.projection) { options.projection = this.projection; }
    if (this.ratio) { options.ratio = this.ratio; }
    if (this.resolutions) { options.resolutions = this.resolutions; }
    // imageLoadFunction?: LoadFunction;

    this.source = new ImageWMS(options);
    this.oLayer = new ImageLayer({
      source: this.source
    });
    this.registerLayer();
  }

  buildFeature(geometry: string, attribute: FieldsInterface, info: WGisFeatureInfo): WGisFeatureInterface {
    return null;
  }

  feature_factory(fields: FieldsInterface, wkt: string, projection?: string): WGisFeatureInterface {
    return null;
  }
  saveSelection(): void {
  }

  // OVERIDE ME
  clearSelection(): void { }
  getSelection(): void { }
  addFeatureToSelection(feature: Feature) { }
  removeFeatureFromSelection(feature: Feature) { }
}
